export const SET_CREDITS = "setCredits";

export const setCredits = (payload: any) => {
  return {
    type: SET_CREDITS,
    payload,
  };
};
